import * as Sentry from '@sentry/browser';
import 'normalize.css/normalize.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
Sentry.init({ dsn: 'https://b84e3a8b326c4ee9912bef173d408550@sentry.io/1888268' });

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
